const STATUSES   = ['New','Qualified','Proposal','Negotiation','Closed Lost','Cold']
const INDUSTRIES = ['Technology','Healthcare','Finance','Retail','Manufacturing','Real Estate','Legal','Other']
const SOURCES    = ['Cold Outreach','Referral','LinkedIn','Inbound','Event','Partner']
const CATEGORIES = [
  'Auto Repair','Accounting','Bar','Beauty Salon','Cafe','Chiropractor',
  'Cleaning Service','Contractor','Dentist','Electrician','Financial Services',
  'Gym','Hair Salon','Hotel','HVAC','Insurance','Law Firm','Landscaping',
  'Med Spa','Medical Practice','Moving Company','Nail Salon','Optometrist',
  'Orthodontist','Pest Control','Pharmacy','Physical Therapy','Plumbing',
  'Real Estate','Restaurant','Roofing','Veterinarian','Yoga Studio',
]

export default function ProspectsToolbar({ filters, onFilter, onAdd, onExport }) {
  return (
    <div style={styles.toolbar}>
      <input
        type="text"
        placeholder="Search company, contact, email..."
        value={filters.search}
        onChange={(e) => onFilter('search', e.target.value)}
        style={styles.search}
      />
      <select value={filters.status} onChange={(e) => onFilter('status', e.target.value)} style={styles.select}>
        <option value="">All statuses</option>
        {STATUSES.map((s) => <option key={s}>{s}</option>)}
      </select>
      <select value={filters.category || ''} onChange={(e) => onFilter('category', e.target.value)} style={styles.select}>
        <option value="">All categories</option>
        {CATEGORIES.map((c) => <option key={c}>{c}</option>)}
      </select>
      <select value={filters.industry} onChange={(e) => onFilter('industry', e.target.value)} style={styles.select}>
        <option value="">All industries</option>
        {INDUSTRIES.map((i) => <option key={i}>{i}</option>)}
      </select>
      <select value={filters.source} onChange={(e) => onFilter('source', e.target.value)} style={styles.select}>
        <option value="">All sources</option>
        {SOURCES.map((s) => <option key={s}>{s}</option>)}
      </select>
      <div style={styles.right}>
        <button style={styles.exportBtn} onClick={onExport}>Export CSV</button>
        <button style={styles.addBtn} onClick={onAdd}>+ Add prospect</button>
      </div>
    </div>
  )
}

const styles = {
  toolbar: {
    display: 'flex', gap: 10, alignItems: 'center',
    flexWrap: 'wrap', marginBottom: '1rem',
  },
  search: {
    flex: 1, minWidth: 200, maxWidth: 260,
    padding: '7px 12px', fontSize: 13,
    border: '0.5px solid #ccc', borderRadius: 8,
    outline: 'none', fontFamily: 'inherit',
  },
  select: {
    padding: '7px 10px', fontSize: 13,
    border: '0.5px solid #ccc', borderRadius: 8,
    background: '#fff', color: '#1a1a1a',
    fontFamily: 'inherit', cursor: 'pointer',
  },
  right: { display: 'flex', gap: 8, marginLeft: 'auto' },
  exportBtn: {
    background: 'none', border: '0.5px solid #ccc',
    borderRadius: 8, padding: '7px 14px', fontSize: 13,
    cursor: 'pointer', color: '#444', whiteSpace: 'nowrap',
  },
  addBtn: {
    background: '#1a1a1a', color: '#fff', border: 'none',
    borderRadius: 8, padding: '7px 14px', fontSize: 13,
    fontWeight: 500, cursor: 'pointer', whiteSpace: 'nowrap',
  },
}
